module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAhCAMAAAABIhAfAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMAIIBg59g/MveSjqp+bVHvnYbYAOO/AAAAYElEQVQoz+3SKxKAMAxF0Vfo/wd0/4ulE9EpCQMSwxURR8QksLrxtIVpMoM+0jKXunQNuBZIHVNHqpiqX7/Qhwtlppm0xXUuNlLRu/paN6kBOKTuQBxqxoZS/PjJ2/89AQTvE/1JxVMEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/common_tel@2x.png
// module id = hPLW
// module chunks = 15